import { useField } from 'react-final-form';

import {
  DEFAULT_SCREEN_4X3_IMAGE_LABEL,
  DEFAULT_SCREEN_1X1_IMAGE_LABEL,
  DEFAULT_SCREEN_9X16_IMAGE_LABEL,
} from '../touchpoint.constants';
import { AssetImageUpload } from '../features/assets-create-page/components/asset-image-upload';

type DefaultScreenImageUploadFieldProps = {
  aspectRatio: '4x3' | '1x1' | '9x16';
  imageFieldName: string;
  urlFieldName: string;
  required?: boolean;
};

export const DefaultScreenImageUploadField = ({
  aspectRatio,
  imageFieldName,
  urlFieldName,
  required = false,
}: DefaultScreenImageUploadFieldProps) => {
  const imageField = useField<File | null>(imageFieldName);
  const urlField = useField<string | null>(urlFieldName);

  const getLabel = () => {
    switch (aspectRatio) {
      case '4x3':
        return DEFAULT_SCREEN_4X3_IMAGE_LABEL;
      case '1x1':
        return DEFAULT_SCREEN_1X1_IMAGE_LABEL;
      case '9x16':
        return DEFAULT_SCREEN_9X16_IMAGE_LABEL;
      default:
        return undefined;
    }
  };

  return (
    <AssetImageUpload
      aspectRatio={aspectRatio}
      fieldName={imageFieldName}
      value={imageField.input.value}
      onChange={imageField.input.onChange}
      urlValue={urlField.input.value}
      onUrlChange={urlField.input.onChange}
      error={imageField.meta.touched && imageField.meta.error ? imageField.meta.error : undefined}
      required={required}
      label={getLabel()}
    />
  );
};

